import React, {
  Component
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../services/fetchTools';
import CircularProgress from 'material-ui/CircularProgress';
import { Table } from 'reactstrap';

class BatchDetails extends Component{
  constructor(props){
    super(props);
    const search = props.location.search; // returns the URL query String
    const params = new URLSearchParams(search);
    this.state = {
      fixture_id: params.get("fid"),
      batch_details:[],
      headers:[],
      loading:true
    }
  }

  componentDidMount() {
    this.getBatchDetails()
  }

  getBatchDetails(){
    const url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=7356&fixture_id=${this.state.fixture_id}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            this.setState({batch_details:data.data,headers:data.headers,loading:false})
           // alert("fix");
       }).catch(error => error);
  }

  render(){
    console.log("state",this.state)
    return(
      <div>
        <div className="breadcrumps" style={{marginBottom:'2%'}}>
          <a href={'/#/dashboard/ActiveCustomer'} >
            <span>Dashboard</span>
          </a>
          <a href={'/#/dashboard/BatchHealth'} >
            <span>Batch Health</span>
          </a> 
          <a>
            <span>Batch Details</span>
          </a>  
        </div>
        {
          this.state.loading ? 
            <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '50%',left: '50%'}}><CircularProgress /></div>
            </div>
          :
        
        <Table responsive style={{border:'1px solid rgb(101, 70, 138)'}}>
          <thead>
            <tr style={{backgroundColor:'rgb(101, 70, 138)',color:'white'}}>
              {/*
                this.state.headers.map(header=>(
                  this.state.batch_details[0][1] ==='Adults'   
                  ?
                    header != 'Subscription Overview' && <th> {header} </th>
                  : 
                  header != '# of games in last 30 days' && <th> {header} </th>
                ))
              */}
              {
                this.state.headers.map(header=>(
                  <th> {header} </th>
                ))
              }
            </tr>
          </thead>
          <tbody>
            {
              this.state.batch_details.map((item,index)=>(
                <tr>
                  <td> {item[0]} </td>
                  <td> {item[1]} </td>
                  <td> {item[2]} </td>
                  <td> {item[3]} </td>
                  <td> {item[4]} </td>
                  <td> 
                    { item[5]!=null && item[5].length > 0 ? <span style={{color:'red'}}> Expired {item[5]} days ago </span>  : 
                      Math.abs(item[5]) >= 0 && Math.abs(item[5]) < 8 ? <span style={{color:'orange'}}> Payment due in  {item[5]} days </span> : <span style={{color:'grey'}}> Active for {item[5]} more days </span>
                    } 
                  </td>
                  <td dangerouslySetInnerHTML={{__html:item[6]}}></td>
                  
                  {/*
                    item[1] != 'Adults' ?  <td> {item[7]} </td> : <td> {item[8]} </td> 
                  */}
                  <td> {item[7]} </td>
                </tr>
              ))
            }
          </tbody>
        </Table>
      }

      </div>
      )
  }

}

export default BatchDetails;


// WEBPACK FOOTER //
// ./src/app/views/centerportal/batchDetails/index.js